//client/src/pages/admin/AdminInternalOrders.js
import { Routes, Route, NavLink } from "react-router-dom";
import AdminInternalOrdersCreate from "./AdminInternalOrdersCreate";
import AdminInternalOrdersList from "./AdminInternalOrdersList";

export default function AdminInternalOrders() {
  return (
    <div className="space-y-6">
      <div className="flex gap-3">
        <NavLink to="" end className="btn-ghost">Place Order</NavLink>
        <NavLink to="status" className="btn-ghost">Order Status</NavLink>
      </div>

      <Routes>
        <Route index element={<AdminInternalOrdersCreate />} />
        <Route path="status" element={<AdminInternalOrdersList />} />
      </Routes>
    </div>
  );
}
